import apiClient, { ApiResponse } from '@/api/api-client'
import type { NotificationPreferences } from '@/api/user/types/User'

export type DeviceTokenPayload = {
  token: string
  platform: 'ios' | 'android'
}

export async function registerDeviceToken(payload: DeviceTokenPayload): Promise<void> {
  await apiClient.post<ApiResponse<unknown>>('/users/me/device-tokens', payload)
}

export async function unregisterDeviceToken(token: string): Promise<void> {
  await apiClient.delete<ApiResponse<unknown>>('/users/me/device-tokens', { data: { token } })
}

export async function updateNotificationPreferences(payload: NotificationPreferences): Promise<NotificationPreferences> {
  const res = await apiClient.patch<ApiResponse<NotificationPreferences>>('/users/me/notification-preferences', payload)
  return res.data.data
}

export async function deleteMyAccount(): Promise<void> {
  await apiClient.delete<ApiResponse<unknown>>('/users/me')
}
